class OftenBoughtAdd extends HTMLElement {
  constructor() {
    super();
    this.miniCart = document.querySelector('mini-cart');
    this.addEventListener('click', this.onClickHandler.bind(this));
  }

  getMainForm() {
    return (
      document.querySelector('.product-form--lastswab form[data-type="add-to-cart-form"]') ||
      document.querySelector('product-form.product-form--lastswab form') ||
      document.querySelector('.product--lastswab-gallery product-form form[data-type="add-to-cart-form"]') ||
      document.querySelector('product-form form[data-type="add-to-cart-form"]')
    );
  }

  getMainVariantId(mainForm) {
    if (!mainForm) return null;
    const mainIdInput = mainForm.querySelector('[name="id"]');
    const mainId = mainIdInput && mainIdInput.value;
    return mainId ? Number(mainId) : null;
  }

  getMainQuantity(mainForm) {
    if (!mainForm) return 1;
    const qtyInput = mainForm.querySelector('[name="quantity"]');
    const qty = qtyInput && qtyInput.value ? Number(qtyInput.value) : 1;
    return qty > 0 ? qty : 1;
  }

  async cartHasVariant(variantId) {
    try {
      const response = await fetch(`${theme.routes.cart_url}.js`);
      const cart = await response.json();
      return (cart.items || []).some((item) => Number(item.variant_id) === Number(variantId));
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  async onClickHandler() {
    if (this.classList.contains('loading') || this.hasAttribute('disabled')) return;

    const caseVariantId = this.dataset.variantId;
    if (!caseVariantId) return;

    const mainForm = this.getMainForm();
    const mainVariantId = this.getMainVariantId(mainForm);
    const mainAlreadyInCart = mainVariantId
      ? await this.cartHasVariant(mainVariantId)
      : false;

    // If main product is already in cart → add case only.
    // If not → add main product + case.
    const items = [];

    if (mainVariantId && !mainAlreadyInCart) {
      items.push({
        id: mainVariantId,
        quantity: this.getMainQuantity(mainForm),
      });
    }

    items.push({
      id: Number(caseVariantId),
      quantity: 1,
    });

    if (document.body.classList.contains('template-cart') || !theme.shopSettings.cartDrawer) {
      // Fallback: add sequentially without drawer sections
      this.setAttribute('disabled', true);
      this.classList.add('loading');

      try {
        for (const item of items) {
          await fetch(`${theme.routes.cart_add_url}`, {
            ...fetchConfig('javascript'),
            body: JSON.stringify(item),
          }).then((r) => r.json());
        }
        window.location.href = theme.routes.cart_url;
      } catch (e) {
        console.error(e);
      } finally {
        this.classList.remove('loading');
        this.removeAttribute('disabled');
      }
      return;
    }

    this.setAttribute('disabled', true);
    this.classList.add('loading');

    const sections = this.miniCart
      ? this.miniCart.getSectionsToRender().map((section) => section.id)
      : [];

    const body = JSON.stringify({
      items,
      sections,
      sections_url: window.location.pathname,
    });

    fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status === 422) {
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:error', {
              detail: {
                errorMessage: parsedState.description,
              },
            })
          );
          return;
        }

        if (this.miniCart) {
          this.miniCart.renderContents(parsedState);
        }

        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: {
              product: parsedState,
            },
          })
        );
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.classList.remove('loading');
        this.removeAttribute('disabled');
      });
  }
}

customElements.define('often-bought-add', OftenBoughtAdd);
